import { useDispatch } from "react-redux"
import CustomButton from './CustomButton'
import { go } from 'redux-first-history'
import { Link } from "react-router-dom";
import Box from '@mui/material/Box';

interface PropsInterface {
  errorMessage?: string
}

const defaultProps: PropsInterface = {
  errorMessage: "An unexpected error has occurred."
}

const ErrorAndBackButton = (propsIn: PropsInterface) => {
  const props = { ...defaultProps, ...propsIn };
  const dispatch = useDispatch();

  return (
    <Box component="div" mt={2}>
      <h4>{props.errorMessage}</h4>
      <p>Sorry about that, please hit Back to try again. If the Back button does not resolve your problem, please <Link to="/help" className="help-link">submit a support ticket</Link> and provide more context to help us solve your issue.</p>
      <CustomButton
        variant="contained"
        label="Back"
        onClick={() => dispatch(go(-1))}
      />
    </Box>
  );
}

export default ErrorAndBackButton;
